import type { JSONNode } from '@atlaskit/editor-json-transformer';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export type SelectionPluginState = {
	lastSelectionContext:
		| {
				localIds: string[] | null;
				selectionFragment: JSONNode[] | null;
		  }
		| undefined;
	nonCursorSelectionChangeCount: number;
};

export const selectionPluginKey = new PluginKey<SelectionPluginState>('aiExperienceSelection');
